module.exports = __webpack_public_path__ + "static/img/dummy-400x300-Bird-plain.7c92d72.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/dummy-400x300-Bird-plain.jpg
// module id = BLXN
// module chunks = 0